<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <header class="header-container">
    <div class="brand">
      <img src="../assets/logo.png" alt="Logo">
      <span class="brand-name">超天才量化开源技术服务</span>
    </div>
    <nav class="nav-menu">
      <button 
        class="nav-btn" 
        @click="$emit('home')"
      >首页</button>
      <button 
        class="nav-btn" 
        @click="$emit('about')"
      >关于我们</button>
    </nav>
  </header>
</template>

<script setup>
</script>

<style scoped>
.header-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 72px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 8%;
  font-size: 16px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand img {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.brand img:hover {
  transform: scale(1.05);
}

.brand-name {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  letter-spacing: 0.5px;
}

.nav-menu {
  display: flex;
  gap: 8px;
}

.nav-btn {
  padding: 10px 24px;
  font-size: 15px;
  font-weight: 500;
  color: #595959;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.nav-btn:hover {
  color: #1890ff;
  background: rgba(24, 144, 255, 0.05);
}

.nav-btn::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: #1890ff;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.nav-btn:hover::after {
  width: 60%;
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 24px;
  }

  .brand-name {
    font-size: 16px;
  }

  .nav-btn {
    padding: 8px 16px;
    font-size: 14px;
  }
}
</style>
